import React from "react";
import { func, string, bool, arrayOf } from "prop-types";
import { AnimatePresence, motion } from "framer-motion";

import MapFilterItem from "./MapFilterItem";

import gtm from "@gtm/core";
import { filterMapTypeEvent } from "@gtm/events/testdrive";
import { testDriveType } from "@types";

const MapFilter = ({ filter, setFilter, isFilterOpen, testDriveTypes }) => {
  const getFilterEvent = (key, label) => () => {
    if (filter === key) {
      setFilter(null);
      return;
    }

    gtm.fire(filterMapTypeEvent(label));
    setFilter(key);
  };

  return (
    <div className="relative h-0">
      <AnimatePresence>
        {isFilterOpen && (
          <motion.div
            variants={{
              open: { opacity: 1, y: "-100%" },
              closed: { opacity: 0 },
            }}
            animate="open"
            initial="closed"
            exit="closed"
          >
            <ul className="flex justify-around items-center gap-8 h-48 bg-white/90 backdrop-blur-sm py-4 overflow-x-auto">
              {testDriveTypes
                ?.filter(testDriveType => testDriveType.status)
                .map(({ id, label, colorHexa }) => (
                  <MapFilterItem
                    data-id={`test-drive-map-filter-item-${id}`}
                    isSelected={!filter || id === filter}
                    key={id}
                    type={id}
                    color={colorHexa}
                    title={label}
                    filterEvent={getFilterEvent(id, label)}
                  />
                ))}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

MapFilter.propTypes = {
  filter: string,
  setFilter: func.isRequired,
  isFilterOpen: bool.isRequired,
  testDriveTypes: arrayOf(testDriveType),
};

export default MapFilter;
